import { connect } from 'react-redux'
import * as customerSelector from '../../state/detail/selector'

import TreatmentExecution from '../detail/TreatmentExecution'


const mapStateToProps = state => {
    return {
        customer: customerSelector.selectCustomer(state),
    }
}

const mapDispatchToProps = {}


export default connect(mapStateToProps, mapDispatchToProps)(TreatmentExecution)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/TreatmentExecutionWidgetContainer.js